export const countries_data = [
  {
    key: '1',
    id: 'CO378258',
    countryName: 'United States',
    countryCode: 'US',
    status: 'Active',
  },
  {
    key: '2',
    id: 'CO378257',
    countryName: 'Canada',
    countryCode: 'CA',
    status: 'Active',
  },
  {
    key: '3',
    id: 'CO378256',
    countryName: 'United Kingdom',
    countryCode: 'UK',
    status: 'Active',
  },
  {
    key: '4',
    id: 'CO378255',
    countryName: 'Germany',
    countryCode: 'DE',
    status: 'Active',
  },
  {
    key: '5',
    id: 'CO378254',
    countryName: 'France',
    countryCode: 'FR',
    status: 'Active',
  },
  {
    key: '6',
    id: 'CO378253',
    countryName: 'Argentina',
    countryCode: 'AR',
    status: 'Active',
  },
  {
    key: '7',
    id: 'CO378252',
    countryName: 'India',
    countryCode: 'IN',
    status: 'Active',
  },
  {
    key: '8',
    id: 'CO378251',
    countryName: 'Italy',
    countryCode: 'IT',
    status: 'Active',
  },
  {
    key: '9',
    id: 'CO378250',
    countryName: 'New Zealand',
    countryCode: 'NZ',
    status: 'Active',
  },
  {
    key: '10',
    id: 'CO378249',
    countryName: 'Australia',
    countryCode: 'AU',
    status: 'Active',
  },
];
